export default "__VITE_ASSET__2aa1b625__"